const FooterText = () => {
  return <footer>Copyright 2022 &#169; Rayhand FV - MD Kurniawan</footer>;
};

export default FooterText;
